export const universeValues = [{value: "SA", label: "SA"}, {value: "SG", label: "SG"}, {value: "SN", label: "SN"}]